angular.module('bbl.common')
  .factory('JsSIP', ['ENV', '$rootScope', _JsSIP]);

var JsSIP = require('jssip');
var isDebug = window.location.hash.indexOf('debug') > -1;
JsSIP.debug[isDebug ? 'enable' : 'disable']('JsSIP:*');

var audio = document.createElement('audio');
$(audio).appendTo('body')
  .attr('id', 'jssip-audio')
  .attr('autoplay', true);

var getUA = function(config) {
  var socket = new JsSIP.WebSocketInterface('wss://'+config.wss);

  var configuration = angular.extend({
    sockets  : [ socket ],
    uri      : ['sip:', config.username, '@', config.realm].join(''),
    password : config.password,

    authorization_user: null,
    display_name: config.username,
    instance_id: null,
    registrar_server: null,
    session_timers: false,
    use_preloaded_route: false
  });

  return new JsSIP.UA(configuration);
};

var types = {
  READY: 'jssip.ready',
  LOGGED_IN: 'jssip.logged',
  TERMINATED: 'jssip.term',
  CALLING: 'jssip.calling',
  ANSWERED: 'jssip.answ',
  MEDIA_PERMISSION: 'jssip.perm'
};

var pub = function(topic, ps) {
  return ps.$emit.bind(ps, topic);
};

function _JsSIP(ENV, $rootScope) {
  var options = {
    mediaConstraints : { 'audio': true },
    rtcOfferConstraints: { offerToReceiveAudio: 1 },
    pcConfig: {
      iceCandidatePoolSize: 0,
      iceTransportPolicy: 'all',  // can be 'relay' to force TURN use
      iceServers: [
        { urls: ["stun:stun.l.google.com:19302"] },
        { urls: ["stun:35.192.167.125:3478"] },
        { urls: ["turn:35.192.167.125:3478?transport=udp"], username:"1001", credential:"1234callers" },
      ]
    },
  };

  var handleStream = function(ev) {
    var stream = ev.stream;

    if(!stream) {
      return;
    }

    audio.srcObject = stream;
    audio.play();

    // watch for track changes
    stream.addEventListener('addtrack', function(event) {
      // if source object changed in the meantime,
      // ignore this event.
      if (audio.srcObject !== stream)
        return;

      // Refresh remote video
      audio.srcObject = stream;
    });
  };

  var CONFIG = angular.copy(ENV.FREESWITCH);
  return {
    init: function(config) {
      // angular.extend(CONFIG, {
      //  username: config.username,
      //  password: config.password,
      // });
    },

    makeCall: function(number, wss) {
      var call;
      var ua = getUA(angular.extend({}, CONFIG, {
        wss:  wss || CONFIG.wss,
      }));

      var callPubsub = $rootScope.$new();

      var callOptions = angular.extend({}, options, {
        eventHandlers: {
          connecting: pub(types.CALLING, callPubsub),
          failed: setTimeout.bind(null, pub(types.TERMINATED, callPubsub)),
          ended: pub(types.TERMINATED, callPubsub),
          confirmed: pub(types.ANSWERED, callPubsub),
        },
      });

      ua.on('registered', ua.call.bind(ua, number.replace(/^\+/, ''), callOptions));
      ua.on('newRTCSession', function(e) {
        call = e.session;
        var peerconnection = call.connection;
        var remoteStream = peerconnection.getRemoteStreams()[0];

        handleStream({stream: remoteStream});
        peerconnection.addEventListener('addstream', handleStream);

        call.on('ended', ua.stop.bind(ua));

        var to;
        call.on('icecandidate', function(ev) {
          clearTimeout(to);
          to = setTimeout(function() {ev.ready();}, 3000);
        });
      });

      ua.start();

      function endCall() {
        ua.terminateSessions();
        ua.unregister();
        ua.stop();
      }

      window.addEventListener('unload', endCall);

      return {
        types: types,
        on: callPubsub.$on.bind(callPubsub),
        end: endCall,


        dtmf: function(digit) {
          if(call) call.sendDTMF(digit);
        },

        mute: function() { if(call) call.mute(); },
        unmute: function() { if(call) call.unmute(); },
      };
    },
  };
}




/*****************
 ** WEBPACK FOOTER
 ** ./app/common/js-sip-service.js
 ** module id = 238
 ** module chunks = 0
 **/